import React, { Component } from 'react'
import { Navigate } from 'react-router-dom'
import { connect } from 'react-redux'
import { deleteUser } from '../../store/user'

const mapDispatchToProps = dispatch => {
  return {
    deleteUser: () => {
      dispatch(deleteUser())
    },
  }
}

class Logout extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showComponent: false,
    }
  }

  render() {
    const { deleteUser } = this.props

    deleteUser()

    return <Navigate to="/login" replace />
  }
}

export default connect(
  null,
  mapDispatchToProps
)(Logout)
